import { render, staticRenderFns } from "./JdsMeridianBadge.vue?vue&type=template&id=27207772&scoped=true&"
import script from "./JdsMeridianBadge.vue?vue&type=script&lang=ts&"
export * from "./JdsMeridianBadge.vue?vue&type=script&lang=ts&"
import style0 from "./JdsMeridianBadge.vue?vue&type=style&index=0&id=27207772&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27207772",
  null
  
)

export default component.exports